<div class="absolute" style="top: 5px;right:5px;z-index:999;">
    <button (click)="close()" style="width:40px; height:40px; vertical-align:middle" class="text-center cursor-pointer hover:bg-[#f5f5f5] hover:rounded-full text-[#626262]"><mat-icon svgIcon="heroicons_outline:x-mark" style="top: 3px !important;position: relative;"></mat-icon></button>
</div>

<mat-dialog-content style="padding:1px;margin:1px;overflow-x:hidden;overflow-y:auto;margin-top:65px !important;margin-bottom:45px !important;">
    <div class="mx-2 absolute" style="top: 14px;">
        <p class="font-bold text-md uppercase text-zinc-700">Set Your Status</p>
        <p class="font-normal text-md text-zinc-700">Select your status for today</p>
    </div>

    <div class="w-full py-0 my-0 mx-2 flex flex-col" style="position:relative;z-index:999">
        <div class="flex flex-wrap overflow-y-auto mr-1">
            <ng-container *ngFor="let status of statusList;">
                <div class="flex flex-wrap my-1 mr-1" style="max-height:26px">
                    <ng-container *ngIf="selectedStatus?.personStatusId == status.personStatusId">
                        <div (click)="selectStatus(status)"
                             [style.background-color]="status.colour"
                             class="flex items-center justify-center py-1 px-3 rounded-full
                                    leading-normal cursor-pointer border-solid bg-[#000f70] text-white">
                            <span class="font-normal whitespace-nowrap text-sm">{{status.name}}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="selectedStatus?.personStatusId != status.personStatusId">
                        <div (click)="selectStatus(status)"
                             [class.border-2]="selectedStatus?.personStatusId != status.personStatusId"
                             [style.border-color]="selectedStatus?.personStatusId != status.personStatusId ? status.colour : 'unset'"
                             class="flex items-center justify-center py-1 px-3 rounded-full leading-normal cursor-pointer border-solid text-[#000f70] bg-gray-100">
                            <span class="font-normal whitespace-nowrap text-sm">{{status.name}}</span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>

        <div class="mt-4">
            <p class="font-bold text-md uppercase text-zinc-700">Until</p>
        </div>
        <div class="flex">
            <input [(ngModel)]="expiry" matInput [matDatepicker]="picker" [disabled]="!selectedStatus?.canSetExpiryDate" [class.opacity-50]="!selectedStatus?.canSetExpiryDate" [readonly]="true"
                   class="text-md font-normal"
                   style="cursor:default;border: 1px solid #000f70;height: 33px !important;top: 3px;position: relative; padding-left:5px;border-radius:5px;margin-right:3px;color:#000;width:140px">
            <mat-datepicker-toggle matIconSuffix [for]="picker" [class.opacity-50]="!selectedStatus?.canSetExpiryDate"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </div>

        <div class="mt-4">
            <p class="font-bold text-md uppercase text-zinc-700">Message</p>
        </div>
        <div class="mr-4">
            <input [(ngModel)]="message" matInput
                   class="text-md font-normal"
                   style="border: 1px solid #000f70;height: 33px !important;padding-left:5px;border-radius:5px;color:#000;width:99%;" />
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="w-full absolute py-0 my-0" style="bottom: 0;">
    <div class="w-full flex justify-between">
        <div class="self-center"></div>
        <div>
        </div>
        <div>
            <button (click)="close()" class="shadow-sm py-1 px-1 mr-3 mb-3 text-sm font-normal rounded-full leading-normal" style="max-height:29px;background-color:transparent;color:#000f70;border: 2px solid #000f70;width:auto">
                <span class="text-sm font-medium whitespace-nowrap mx-2">Cancel</span>
            </button>

            <!-- as per OMB-7580 -->
            <!--<button [disabled]="expiry == null && selectedStatus?.canSetExpiryDate"
                    [class.border-2]="!(expiry == null && selectedStatus?.canSetExpiryDate)"
                    [class.border-[#000f70]]="!(expiry == null && selectedStatus?.canSetExpiryDate)"
                    (click)="save()" class="shadow-sm py-1 px-1 mr-3 mb-3 text-sm font-normal rounded-full leading-normal" style="max-height:29px;background-color:transparent;color:#000f70;width:auto">
                <span class="text-sm font-medium whitespace-nowrap mx-2">Save</span>
            </button>-->

            <button (click)="save()" class="border-2 border-[#000f70] shadow-sm py-1 px-1 mr-3 mb-3 text-sm font-normal rounded-full leading-normal" style="max-height:29px;background-color:transparent;color:#000f70;width:auto">
                <span class="text-sm font-medium whitespace-nowrap mx-2">Save</span>
            </button>
        </div>
    </div>
</mat-dialog-actions>

